import { ProcessorType } from "../../../../types/processor.types";

export interface AddMidForm {
    processorId: string;
    midName: string,
    trashHoldLimit?: number
    md5: string;
    privateKey: string;
    midCode: string;
    midDescriptor: string;
    commissions: CommissionFormField[];
}

export interface CommissionFormField {
    value: number;
    valueType: CommissionValueType;
    type: CommissionType;
}

export enum CommissionValueType {
    PERCENT = 'PERCENT',
    FIXED = 'FIXED'
}

export enum CommissionType {
    MDR = 'MDR',
    ROLLING = 'ROLLING',
    TRANSACTION = 'TRANSACTION',
    REFUND = 'REFUND',
    CHARGEBACK = 'CHARGEBACK',
    SETTLEMENT = 'SETTLEMENT',
    CHARGEBACK_ALERT = 'CHARGEBACK_ALERT',
    RDR = 'RDR'
}

export interface ProcessorData {
    id: number,
    processorType: ProcessorType,
    processorName: string;
}

